module.exports = __webpack_public_path__ + "static/media/400338_02.b0e4786f.png";